import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { ForbiddenDialogService } from '../../dialogs/forbidden-dialog.service';
import { AppError } from '../../errors/app-error';
import { IS_API_REQUEST, SKIP_FORBIDDEN_DIALOG } from '../api-context';

/**
 * Global HTTP error UX — runs after the error normaliser on the response
 * chain so feature code still receives typed `AppError`s.
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.context.get(IS_API_REQUEST)) {
    return next(req);
  }

  const forbiddenDialog = inject(ForbiddenDialogService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof AppError &&
        error.kind === 'forbidden' &&
        !req.context.get(SKIP_FORBIDDEN_DIALOG)
      ) {
        forbiddenDialog.show(error.message);
      }
      return throwError(() => error);
    }),
  );
};
